import { createActions } from 'redux-actions';
export const actions = createActions({}, 'VISIBILITY_HIDDEN', 'VISIBILITY_SHOWN', 'VISIBILITY_START', 'VISIBILITY_STOP');
